<a [hidden]="!priceUpsert" class="btn btn-success m-btn m-btn--custom m-btn--icon" (click)="addField()">
  <span>{{ 'price-new.addPrice' | transloco }}</span>
</a>

<ng-container *ngIf="storeProductId">
  <div class="form-group m-form__group m--padding-bottom-15" style="padding-bottom: 0;" *ngFor="let item of list; let i = index">
    <div class="row m--margin-bottom-5">
      <div class="col-md-4"></div>

      <div class="col-md-4 col-sm-12">
        <label class="is--required">{{ 'price-new.volume' | transloco }}:</label>

        <input [disabled]="!priceUpsert" type="text" class="form-control m-input" [placeholder]="'price-new.size' | transloco" [(ngModel)]="list[i].amount">
      </div>

      <div class="col-md-4 col-sm-12">
        <label class="is--required">{{ 'price-new.price' | transloco }}</label>

        <input [disabled]="!priceUpsert" type="text" class="form-control m-input" [placeholder]="'price-new.price' | transloco" [(ngModel)]="list[i].value">
      </div>
    </div>

    <div class="row">
      <div class="col-md-4"></div>

      <div class="col-lg-4 col-md-4 col-sm-12">
        <label class="is--required">{{ 'price-new.weight' | transloco }}</label>

        <input [disabled]="!priceUpsert" type="text" class="form-control m-input" [placeholder]="'price-new.weight' | transloco" [(ngModel)]="list[i].weight">
      </div>
    </div>

    <div class="row">
      <div class="col-md-4"></div>

      <div class="col-lg-4 col-md-4 col-sm-12">
        <label class="is--required">{{ 'price-new.active' | transloco }}</label>
        <hx-date-select [disabled]="!priceUpsert" [(ngModel)]="item.fromDate" [minDate]="today"></hx-date-select>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4"></div>

      <div class="col-lg-8 col-md-8 col-sm-12">
        <label class="is--required">{{ 'price-new.component' | transloco }}</label>

        <ng-select [disabled]="!priceUpsert" bindLabel="label" bindValue="id" [multiple]="true" [placeholder]="'price-new.component' | transloco" [(ngModel)]="list[i].components">
          <ng-option *ngFor="let op of typeOptions" [value]="op.id">{{op.label | transloco}}</ng-option>
        </ng-select>
      </div>
    </div>

    <div class="row m--padding-top-10">
      <div class="col-md-4"></div>
      <div class="col-md-2">
        <span class="m-switch m-switch--icon m-switch--outline  m-switch--success" [ngbTooltip]="(list[i].enabled? 'price-new.disablePrice' : 'price-new.onPrice') | transloco">
          <label class="m--margin-bottom-0">
            <input type="checkbox" [(ngModel)]="list[i].enabled" (change)="changeSwitchPrice(list[i])">
            <span></span>
          </label>
        </span>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-10 text-right">
        <span [ngbTooltip]="(priceUpsert ? 'price-new.delete' : 'price-new.noAccess')"><button [disabled]="!priceUpsert" type="button" class="btn btn-danger" (click)="removeField(item, i)">{{ 'btn.delete' | transloco }}</button></span>
        <span [ngbTooltip]="priceUpsert ? 'price-new.save' : 'price-new.noAccess'"><button [disabled]="!priceUpsert" type="button" class="btn btn-success" (click)="savePrices(item)">{{ 'btn.save' | transloco }}</button></span>
      </div>
    </div>
  </div>

  <hx-loader [length]="list.length" [isLoading]="isLoading.list"></hx-loader>
</ng-container>
